import { BaseService } from './base.service'
import { Http } from './http.init'
import { BACKEND_URL } from '../env'
import axios from 'axios'
import { ErrorWrapper, ResponseWrapper } from './utils'

var Vue = require('vue')

export class ProfileService extends BaseService {
  static get entity () {
    return 'profile_dictionary_entries'
  }

  static request (status = { auth: true }) {
    return new Http(status)
  }

  static getProfileDictionaryEntryStatistics (username) {
    const url = `${BACKEND_URL}/dictionary_entry/profile_dictionary_entries/?username=${username}`
    const authToken = Vue.default.cookie.get('token')
    let headersConfig = {}
    if (authToken) {
      headersConfig = this.request().request
    }
    return new Promise((resolve, reject) => {
      axios.get(url, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => {
          reject(new ErrorWrapper(error))
        })
    })
  }

  static updatePlaceholder (username, newPlaceholder) {
    if (username === 'anonymous') return Promise.resolve('anonymous')
    const url = `${BACKEND_URL}/auth/shortform-placeholder/${newPlaceholder}/?username=${username}`
    let authToken = Vue.default.cookie.get('token')
    if (!authToken) {
      authToken = localStorage.getItem('genderAppToken')
    }
    let headersConfig = {}
    if (authToken) {
      headersConfig = this.request().request
    }
    return new Promise((resolve, reject) => {
      axios.get(url, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => {
          reject(new ErrorWrapper(error))
        })
    })
  }
}
